module.exports = __webpack_public_path__ + "img/g矩形 83@1x.9f56d8eb.png";